export type LocalStorageKey = 'leadsViewSelected'
type LocalStorageValues = {
  leadsViewSelected: 'list' | 'pipeline'
}

export const setLocalStorage = <K extends LocalStorageKey>(
  key: K,
  value: LocalStorageValues[K]
): void => {
  localStorage.setItem(key, JSON.stringify(value))
}

export const getLocalStorage = <K extends LocalStorageKey>(
  key: K
): LocalStorageValues[K] | null => {
  const value = localStorage.getItem(key)
  return value ? JSON.parse(value) : null
}
